var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragraphImage",class:this.field_image_margin},[(_vm.view_type === 'paragraphImage_carousel')?[_c('div',{staticClass:"fieldImage__slider"},[_c('div',{staticClass:"fieldImage__sliderBody"},[_c('Carousel2',{attrs:{"mergeOptions":({
            initialSlide: 2,
            slidesPerView: 1.3,
            spaceBetween: 12,
            loop: true,
            centeredSlides: true,
            autoplay: {
              delay: 6000,
            },
            pagination: {
              el: ".c-carousel__pagination",
              clickable: true
            },
            navigation: {
              nextEl: ".c-carousel__next",
              prevEl: ".c-carousel__prev"
            },
            breakpoints: {
              1024: {
                slidesPerView: 3,
                spaceBetween: 24
              }
            }
          })}},_vm._l((_vm.images),function(item){return _c('swiper-slide',{key:item.id},[_c('a',{attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.src,"alt":item.alt}})])])}),1)],1)])]:[(_vm.images.length === 1)?[_c('div',{staticClass:"fieldImage"},_vm._l((_vm.images),function(item){return _c('a',{key:item.id,attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.src,"alt":item.alt}}),(item.text)?_c('p',[_vm._v(_vm._s(item.text))]):_vm._e()])}),0)]:(_vm.images.length > 1)?[_c('div',{class:_vm.imageColumn},_vm._l((_vm.images),function(item){return _c('a',{key:item.id,staticClass:"fieldImages_item",attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.src,"alt":item.alt}}),(item.text)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()])}),0)]:_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }